import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {AsyncPipe, TitleCasePipe} from '@angular/common';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {ViewBreakpointService, ViewSize} from '../../app-services/view-breakpoint.service';
import {HeaderNavItem} from './header-nav-item';

@Component({
  selector: 'cmn-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrl: './header-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TitleCasePipe, MatBadgeModule, MatButtonModule, MatIconModule, MatMenuModule, TranslateModule]
})
export class HeaderNavComponent {

  @Input() items: HeaderNavItem[] = [];

  @Input() activeValue: string;

  /** Подписи под иконками видны, когда ширина экрана больше указанного размера. */
  @Input() labelsFrom: 's' | 'm' | 'l' | 'xl' = 'l';

  @Output() select = new EventEmitter<HeaderNavItem>();

  readonly size$: Observable<ViewSize>;

  constructor(viewBreakpointService: ViewBreakpointService) {
    this.size$ = viewBreakpointService.size$;
  }

  /** Пункт для кнопки мобильного меню: активный, а пока активного нет — первый в списке. */
  get activeItem(): HeaderNavItem {
    return this.items?.find(item => item.value === this.activeValue) ?? this.items?.[0];
  }
}
